<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableLogManagementDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <Button
          type="info"
          size="small"
          v-hasPermission="['monitor:logManagementMonitor:queryLogDetails']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableLogManagementVue = {};
export default {
  name: "TableLogManagement",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      region: "",
      columns: [
        {
          title: this.$t("alarms.logService.logStoreName"),
          key: "logstoreName"
        },
        {
          title: this.$t("alarms.common.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.common.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.logService.projectName"),
          key: "projectName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state"
        },
        {
          title: this.$t("alarms.logService.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "detail"
        }
      ],
      tableLogManagementDate: []
    };
  },
  beforeCreate: function() {
    tableLogManagementVue = this;
  },
  created() {
    eventBus.$on("logstoreNameSearchName", function(val) {
      tableLogManagementVue.val = val;
    });
    eventBus.$on("companyId", function(val) {
      tableLogManagementVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableLogManagementVue.getLogManagementData();
    },
    // 分页显示数据
    /****************************************************/
    getLogManagementData: function() {
      //列表分页
      this.$api.log
        .pageLog({
          companyId: tableLogManagementVue.companyId,
          logstoreName: tableLogManagementVue.val,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 17
        })
        .then(res => {
          this.tableLogManagementDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableLogManagementVue.getLogManagementData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableLogManagementVue.getLogManagementData();
    },
    // 销毁logstoreNameSearchName
    beforeDestroy: function() {
      eventBus.$off("logstoreNameSearchName");
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/logManagementDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          projectName: row.projectName,
          logstoreName: row.logstoreName,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/log_management/TableLogManagement.vue